<template>
  <VContainer>
    <VCard>
      <VCardTitle>
        {{ $t('doNotSellTitle') }}
      </VCardTitle>
      <VCardText>
        {{ $t('doNotSellText.1') }}
        <RouterLink to="/confidential">
          {{ $t('doNotSellTextLink') }}
        </RouterLink>.
        {{ $t('doNotSellText.2') }}
        <a :href="`mailto:${SUPPORT_EMAIL}?subject=Do Not Sell My Personal Information`">{{ SUPPORT_EMAIL }}</a>:
        {{ $t('doNotSellText.3') }}
        </VList>
      </VCardText>
    </VCard>
  </VContainer>
</template>

<script>
import { SUPPORT_EMAIL } from '@/helpers/constants';

export default {
  name: 'DoNotSellPersonal',
  data() {
    return {
      SUPPORT_EMAIL,
    };
  },
  metaInfo() {
    return {
      title: 'Do Not Sell My Personal Information',
    };
  },
};
</script>

<i18n locale="en" lang="yaml">
doNotSellTitle: Do Not Sell My Personal Information
doNotSellTextLink: here
doNotSellText: {
  1: 'Please be advised that Huntica (Boson, Inc.) does not, and has not sold any personal information in the last 12 (twelve) months. See the Huntica’s Privacy Policy',
  2: 'Likewise, Huntica does not have any future plans to sell personal information.
        However, Huntica respects and understands that you may still want to ensure your personal information is not sold.
        Therefore, if you would still like to proceed with your “do not sell my information” request, we ask that you kindly provide the following information via email',
  3: 'First Name, Last Name, Email, Address, City, State, Postal Code, Country.'
}
</i18n>

<i18n locale="ru" lang="yaml">
doNotSellTitle: Не распространять мою личную информацию
doNotSellTextLink: здесь
doNotSellText: {
  1: 'Обратите внимание, что компания Huntica (Boson, Inc.) не продаёт и не продавала никакую персональную информацию за последние 12 (двенадцать) месяцев. См. Политику конфиденциальности Huntica.',
  2: 'Аналогичным образом, Huntica не планирует в будущем продавать персональные данные.
        Тем не менее, Huntica уважает и понимает, что вы все равно можете хотеть убедиться, что ваши персональные данные не будут проданы.
        Поэтому, если вы все же хотите продолжить обработку вашего запроса «не продавайте мою информацию», мы просим вас предоставить следующую информацию по электронной почте.',
  3: 'Имя, Фамилия, Электронная почта, Адрес, Город, Штат, Почтовый индекс, Страна.'
}
</i18n>
